﻿import React from "react";
import { Icon } from "@blueprintjs/core";
import { Tooltip } from "components/tooltip/Tooltip";
import PropTypes from "prop-types";
import classNames from "classnames";
import "components/navigation/Navigation.css";

export function Tabs(
    {
        className = "",
        loading = false,
        disabled = false,
        singleRow = false,
        variant = "default",
        onClick,
        tabs
    }
) {
    function onTabClick(tab, index) {
        if (tab.disabled === true || disabled === true) {
            return;
        }

        onClick(index);
    }

    const isPill = variant === "pill";

    return (
        <div
            className={classNames("bp6-tabs bp6-horizontal", {
                "tablist-single-row": singleRow,
            }, className)}
        >
            <ul
                className={classNames("bp6-tab-list", {
                    "bp6-skeleton": loading,
                })}
            >
                {tabs.map((l, index) => {
                    const liElement = (
                        <li
                            className={classNames("bp6-tab",
                                l.className,
                                {
                                    "bp6-skeleton": loading,
                                    "tab-disabled": l.disabled || disabled,
                                    "pill-tab": isPill,
                                })}
                            key={l.title}
                            role="tab"
                            aria-selected={l.selected}
                            onClick={() => onTabClick(l, index)}
                            onKeyDown={(e) => { }}
                        >
                            {l.icon ? (
                                <div className="center-icon">
                                    {l.title}{" "}
                                    <Icon icon="comment" size={12} />
                                </div>
                            ) : (
                                l.title
                            )}
                        </li>
                    );
                    if (l.showTooltip) {
                        return (
                            <Tooltip
                                content={l.toolTipMessage}
                                key={l.title + "-tooltip"}
                            >
                                {liElement}
                            </Tooltip>
                        );
                    }
                    return liElement;
                })}
            </ul>
        </div>
    );
}

Tabs.propTypes = {
    tabs: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    singleRow: PropTypes.bool,
    variant: PropTypes.oneOf(["default", "pill"]),
};
